import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class AdminSubscriptionsToProcessDetailsResponse {
  @jsonMember(Boolean)
  public readonly isBulkProcessAvailable!: boolean;

  @jsonMember(Number)
  public readonly itemsToProcess!: number;

  @jsonMember(Date)
  public readonly nextScheduledProcessingDate!: Date;

  @jsonMember(String)
  public readonly soldBoxId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly soldBoxName?: Nillable<string>;
}
